import { render, staticRenderFns } from "./SimpleQueryBuilderGroup.vue?vue&type=template&id=84c83244&scoped=true&"
import script from "./SimpleQueryBuilderGroup.vue?vue&type=script&lang=js&"
export * from "./SimpleQueryBuilderGroup.vue?vue&type=script&lang=js&"
import style0 from "./SimpleQueryBuilderGroup.vue?vue&type=style&index=0&id=84c83244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c83244",
  null
  
)

export default component.exports